import React, { useState, useEffect } from "react";
import { Container } from "@mui/material";
import Successmark from "../../../../assets/images/Successmark.png";
import MainButton from "../../../shared/Button";
import { useNavigate } from "react-router-dom";
import {
  PendingApprovalMain,
  PendingImg,
  PendingText,
} from "../styles/ProfilePasswordChangeStyle";
import { useDispatch, useSelector } from "react-redux";
import { USERINFO } from "../../../../constants/apiEndPoints";
import httpRequest from "../../../../axios/index";
import { loginSuccess } from "../../../../redux/slice/user/UserSlice";
import { toast } from "react-hot-toast";

const ProfileApproved = () => {
  const navigate = useNavigate();
  const [Loading, setLoading] = useState(false);
  const UserInformation = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    const user = UserInformation?.user;

    if (user) {
      if (user.status === "pending" && user.user_type === null) {
        navigate("/customer-type");
      } else if (
        user.status === "active" &&
        !user.payment_method &&
        UserInformation?.user?.review_approved
      ) {
        navigate("/payment-method");
      } else if (
        user.status === "active" &&
        user.review_approved &&
        user.payment_method
      ) {
        navigate("/profile");
      } else if (user.status === "pending") {
        navigate("/pending-appproval");
      }
    }

    // if (UserInformation?.user?.status === "pending") {
    //   navigate("/pending-appproval");
    // } else if (
    //   UserInformation?.user?.status === "pending" &&
    //   UserInformation?.user?.user_type === null
    // ) {
    //   navigate("/customer-type");
    // } else if (
    //   UserInformation?.user?.status === "active" &&
    //   !UserInformation?.user?.payment_method
    // ) {
    //   navigate("/payment-method");
    // } else if (
    //   UserInformation?.user?.status === "active" &&
    //   UserInformation?.user?.review_approved &&
    //   UserInformation?.user?.payment_method
    // ) {
    //   navigate("/profile");
    // }
  }, [UserInformation]);

  const UpdateApprovedhandle = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const resp = await httpRequest.patch(USERINFO, {
        user: {
          review_approved: true,
        },
      });

      if (resp?.status === 200) {
        const userToken = { auth_token: UserInformation?.user?.auth_token };
        const UserData = { ...resp?.data?.user, ...userToken };
        navigate("/payment-method");
        dispatch(loginSuccess(UserData));
      }
      setLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      setLoading(false);
    }
  };

  return (
    <>
      <Container maxWidth="lg">
        <PendingApprovalMain>
          <PendingImg>
            <img src={Successmark} alt="Successmark" />
          </PendingImg>
          <PendingText>
            <h6>Profile Approved!</h6>
            <p>Congratulations! Your profile is successfully approved.</p>
          </PendingText>
          <MainButton
            type="button"
            label="Add Payment Method"
            MT="140"
            onClick={UpdateApprovedhandle}
            isLoading={Loading}
          />
        </PendingApprovalMain>
      </Container>
    </>
  );
};

export default ProfileApproved;
